var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.field?.label ?? _vm.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }